export function formatErrorMessage(error: any): string {
  if (error?.response?.data?.code) {
    return `${error.response.data.message || error?.response?.data?.code}`;
  }

  if (error instanceof Error) {
    return `${error.message || error.name || error.stack}`;
  }

  if (typeof error === 'string' || typeof error === 'number') {
    return `${error}`;
  }

  return error.message || error.response?.statusText || error.code || error.status || error.statusCode || error.stack;
}
